<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display: flex;justify-content: flex-start;align-items: center;">
        <button-add @click="toAddPage1" value="发票用电量" v-if="permissionCodes.indexOf('040005003') !== -1"></button-add>
<!--        <button-add @click="toAddPage2" value="生成账单" v-if="permissionCodes.indexOf('040005001') !== -1"></button-add>-->
        <button-cancel value="生成账单" @cancel="toAddPage2" v-if="permissionCodes.indexOf('040005001') !== -1" style="margin-left: 10px;"/>
      </div>
    </div>
    <table-main :hasOperation="false" :selection="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%">
      <div class="form-line">
            <div class="textBox">
              <b class="red">*</b>
              <span class="line-text">账期：</span>
            </div>
              <el-select v-model="templateCodes"
                        filterable
                        remote
                        reserve-keyword
                        size="small" style="width: 280px"
                        :remote-method="remoteMethod"
                        placeholder="请选择模板名称">
                <el-option v-for="item in templateList" :key="item.cycle"
                          :label="item.cycle" :value="item.cycle">
                </el-option>
              </el-select>
          </div>
      <div class="form-line">
            <div class="textBox">
              <b class="red">*</b>
              <span class="line-text">总分摊电量：</span>
            </div>
              <el-input v-model="formData.totalShareElectricity" size="small" style="width: 280px" disabled/>
          </div>
      <div class="form-line">
            <div class="textBox">
              <b class="red">*</b>
              <span class="line-text">添加时间：</span>
            </div>
              <el-input v-model="formData.addTime" size="small" style="width: 280px" disabled/>
          </div>
      <div class="form-line">
            <div class="textBox">
              <b class="red">*</b>
              <span class="line-text">是否使用：</span>
            </div>
              <el-input v-model="formData.usedText" size="small" style="width: 280px" disabled/>
          </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="confirm()" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/common/buttons/button-add";
import InputSearch from "../../../components/Input/InputSearch";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/PropertyFee";
import { errorHandler } from "../../../utils/errorHandler";
import { nError, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";
import ButtonCancel from "../../../components/Button/ButtonCancel";

export default {
  components: {
    ButtonCancel,
    TableMain,
    InputSearch,
    ButtonAdd,
    Breadcrumb
  },
  name: "electricity-share-fee",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "纳爱斯专属",
          name: "property-fee-management"
        },
        {
          value: "分摊用电费用"
        }
      ],
      tableHead: [
        {
          prop: "enterpriseName",
          label: "住户名称"
        },
        {
          prop: "lastElectricity",
          label: "上期示数"
        },
        {
          prop: "firstElectricity",
          label: "本期示数"
        },
        {
          prop: "cycle",
          label: "账期"
        },
        {
          prop: "usedElectricity",
          label: "用电量(kwh)"
        },
        {
          prop: "sharedElectricity",
          label: "分摊后用电量"
        },
        {
          prop: "shareElectricity",
          label: "分摊读数"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      requestData: {
        pageSize: 10,
        pageNum: 1
      },
      dialogVisible: false,
      formData: {},
      templateCodes: "",
      templateList: []
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  methods: {
    toAddPage1() {
      this.$router.push({
        name: "invoice-power-consumption"
      });
    },
    remoteMethod() {
      this.getUnusedBillConfig();
    },
    toAddPage2() {
      this.getUnusedBillConfig();
      this.dialogVisible = true;
    },
    getUnusedBillConfig() {
      this.$axios
        .get(api.getUnusedBillConfig, {})
        .then(res => {
          this.templateList = res.data.data;
        })
        .catch(errorHandler("查询失败"));
    },
    getPage() {
      this.$axios
        .post(api.getShareBillPage, this.requestData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    confirm() {
      if (!this.formData.cycle) {
        nError("请选择账期");
        return false;
      }
      this.$axios
        .post(api.useBillConfig, this.formData)
        .then(res => {
          nSuccess("添加成功");
          this.dialogVisible = false;
          this.formData = {};
          this.getPage();
        })
        .catch(errorHandler("添加失败"));
    }
  },
  watch: {
    templateCodes(val) {
      this.templateList.map(v => {
        if (v.cycle === val) {
          this.formData.cycle = v.cycle;
          this.formData.totalShareElectricity = v.totalShareElectricity;
          this.formData.addTime = v.addTime;
          this.formData.used = v.used;
          if (v.used) {
            v.usedText = "是";
          } else {
            v.usedText = "否";
          }
          this.formData.usedText = v.usedText;
        }
      });
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/PropertyFee/electricityShareFee/electricityShareFee.vue